import React from 'react'
import avatar403 from '../../../assets/img/errors/403/protection, security, shield, fight, safety 1.svg'
import error403 from '../../../assets/img/errors/403/403-2.svg'
import { Row, Col } from 'react-bootstrap'

const Error403: React.FC = () => {
  return (
    <div className="d-flex min-vh-100 align-items-center justify-content-center">
      <Row>
        <Col>
          <div>
            <img src={error403} />
          </div>
          <div className="fw-bold fs-6 my-2">Acceso Denegado!</div>
          <div className="mb-2">
            Parece que no estás en la lista de invitados, prueba de <br /> nuevo.
          </div>
          <a href="/" className="btn btn-primary">
            Volver al inicio
          </a>
        </Col>

        <Col>
          <div className="container text-center">
            <img src={avatar403} />
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default Error403
